/** Bump when Turf buffer / corridor pipeline semantics change. */
export const CORRIDOR_BUFFER_ALGORITHM_VERSION = 1;

/** Default TTL for cached corridor GeoJSON (10 days). */
export const CORRIDOR_BUFFER_CACHE_TTL_MS = 10 * 24 * 60 * 60 * 1000;

/** Max in-memory corridor FC entries before LRU eviction. */
export const CORRIDOR_BUFFER_MEMORY_CACHE_MAX_ENTRIES = 128;
